/* tslint:disable */
/* eslint-disable */
/**
 * E.ON Home Dashboard - API
 * This API provides access and control function for smart equipped homes. For near real-time information please use this API here https://sse-hems-dev2.eon.ooo/docs/. `[NOTE]` The access token for the current user session is also valid for the real-time API utilising SSE (Server Sent Event)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: sebastian.eggers@eon.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Forbidden,
  NotFound,
  Unauthorized,
  UserDataDownloadInfoModel,
  UserDataDownloadUriModel,
} from '../models';

export interface UserV2ControllerGetDownloadUriRequest {
    dumpId: string;
    fileFormat: string;
}

/**
 * 
 */
export class UserV2ControllerApi extends runtime.BaseAPI {

    /**
     * Get list of available GDPR data exports for the authenticated user
     * Get available GDPR data dumps initiated by the user
     */
    async userV2ControllerGetDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserDataDownloadInfoModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/user:read"]);
        }

        const response = await this.request({
            path: `/api/v2/me/gdpr/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get list of available GDPR data exports for the authenticated user
     * Get available GDPR data dumps initiated by the user
     */
    async userV2ControllerGetData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserDataDownloadInfoModel>> {
        const response = await this.userV2ControllerGetDataRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get download URI for a specific GDPR data export file
     * Get GDPR download url
     */
    async userV2ControllerGetDownloadUriRaw(requestParameters: UserV2ControllerGetDownloadUriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDataDownloadUriModel>> {
        if (requestParameters.dumpId === null || requestParameters.dumpId === undefined) {
            throw new runtime.RequiredError('dumpId','Required parameter requestParameters.dumpId was null or undefined when calling userV2ControllerGetDownloadUri.');
        }

        if (requestParameters.fileFormat === null || requestParameters.fileFormat === undefined) {
            throw new runtime.RequiredError('fileFormat','Required parameter requestParameters.fileFormat was null or undefined when calling userV2ControllerGetDownloadUri.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["policy/hems/user:read"]);
        }

        const response = await this.request({
            path: `/api/v2/me/gdpr/{dumpId}/download_uri/{fileFormat}`.replace(`{${"dumpId"}}`, encodeURIComponent(String(requestParameters.dumpId))).replace(`{${"fileFormat"}}`, encodeURIComponent(String(requestParameters.fileFormat))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get download URI for a specific GDPR data export file
     * Get GDPR download url
     */
    async userV2ControllerGetDownloadUri(requestParameters: UserV2ControllerGetDownloadUriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDataDownloadUriModel> {
        const response = await this.userV2ControllerGetDownloadUriRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
